/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Session_Schedule_StepInputs */

const en_session_schedule_step = /** @type {(inputs: Session_Schedule_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Step 2 of 2 · Day and portions`)
};

const de_session_schedule_step = /** @type {(inputs: Session_Schedule_StepInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schritt 2 von 2 · Tag und Portionen`)
};

/**
* | output |
* | --- |
* | "Step 2 of 2 · Day and portions" |
*
* @param {Session_Schedule_StepInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const session_schedule_step = /** @type {((inputs?: Session_Schedule_StepInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Session_Schedule_StepInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_session_schedule_step(inputs)
	return en_session_schedule_step(inputs)
});